import {IHttpService, IPromise} from "angular";

export class DisciplineService {

    /* @ngInject */
    constructor(private $http: IHttpService) {
    }

    public search(query: string): IPromise<any[]> {
        return this.$http.get("/api/disciplines", {params: {query: query}})
            .then((resp) => {
                return resp.data as any[];
            });
    }

}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/assessment/discipline-selector/discipline.service.ts